import { DonationIcon, InfoIcon } from '../../../../../images';
import styled from '@emotion/styled';
import ReceiptCheck from './Icons/ReceiptCheck';
import QuestionMark from './Icons/QuestionMark';
import { device, isMobile, SvgWrapper } from '../../../../../utils';
import React from 'react';
import { BookmarkIconWithoutBackground } from '../Modals/Icons';

export default function DonationNotice({project, onPress}) {

  return (
    <NoticesWrapper onClick={onPress}>
      {project?.donation_receipts_possible && (
        <NoticeWrapper>
          <BookmarkIconWithoutBackground />
          <NoticeText>
            Der Projektinitiator kann Spendenquittungen ausstellen.
          </NoticeText>
          {!isMobile() && <QuestionMark />}
        </NoticeWrapper>
      )}
    </NoticesWrapper>
  );
  
}

const NoticesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  min-width: 336px;
  cursor: pointer;
  @media ${device.allMobile} {
    gap: 3px
  }
`;

const NoticeWrapper = styled.div`
  background: #f5fbee;
  border: 1px solid #ceeab0;;
  padding: 4px 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: fit-content;
  justify-self: center;
  align-self: center;
  margin: 0 auto;
  border-radius: 999px;
  gap: 6px;
  @media ${device.allMobile} {
    gap: 3px;
  }
`;

const NoticeText = styled.span`
  color: #3f621a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: 'Inter', sans-serif;
  text-align: center;

  @media ${device.allMobile} {
    /* Text xs/Regular */
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 18px;
    /* identical to box height, or 150% */

  }
`;
